export default __webpack_public_path__ + "static/media/china_logo.027c1df9.svg";